export default __webpack_public_path__ + "static/media/IRC-150.c8cc4d78.png";